import Qrcode from 'qrcode.react'

function SignSuccess() {
  return (
    <div className='text-center'>
      <Qrcode className='mx-auto mt-20 mb-10' size={200} value={window.location.href} />
      <div className='text-3xl text-blue-600 mx-10 mb-2 leading-relaxed'>核验成功</div>
    </div>
  )
}

export default SignSuccess
